import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("os_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const img = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "/products/hero.jpg");

export const tl = (n) =>
  `${Number(n || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Bir hata oluştu, tekrar deneyin.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const waLink = (number, text) => {
  const n = String(number || "").replace(/\D/g, "").replace(/^0/, "90");
  return `https://wa.me/${n}?text=${encodeURIComponent(text || "")}`;
};

export const CATEGORIES = [
  { key: "kedi", label: "Kedi" },
  { key: "kopek", label: "Köpek" },
  { key: "kus", label: "Kuş" },
  { key: "balik", label: "Balık" },
];

export const catLabel = (k) => CATEGORIES.find((c) => c.key === k)?.label || k;
